<section *ngIf="cards">
    <app-home-cards [cards]="cards"></app-home-cards>
</section>
